<template>
  <div class="systemManage-create create-image">
    <el-dialog
      v-model="dialogVisible"
      :title="$t('lcd.Devices.Add AD')"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="800px"
    >
      <div class="form-box">
        <el-form
          label-position="top"
          style="width: 100%"
          :model="formData"
          ref="form"
          :rules="rules"
          size="small"
        >
          <el-form-item :label="$t('lcd.Devices.Store ID')" prop="storeId">
            <el-input
              v-model="formData.storeId"
              placeholder=""
              clearable
              disabled
            />
          </el-form-item>
          <el-form-item :label="$t('lcd.Devices.AD Type')" prop="launchType">
            <el-select
              v-model="formData.launchType"
              clearable
              :placeholder="$t('layout.Select')"
              @change="launchTypeChange"
            >
              <el-option
                v-for="item in launchTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- formData.launchType为1时是制定设备 formData.launchType为2时是指定分组  -->
          <el-form-item
            v-if="formData.launchType == 1 || formData.launchType == 2"
            :label="$t('lcd.Devices.Device List')"
            prop="launchEquipmentList"
          >
            <!-- {{lcdListOptions}} -->
            <el-select
              v-if="formData.launchType == 1"
              v-model="formData.launchEquipmentList"
              multiple
              filterable
              remote
              automatic-dropdown
              :reserve-keyword="false"
              :placeholder="$t('lcd.Devices.Please Input Device ID')"
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option
                v-for="item in lcdListOptions"
                :key="item.code"
                :label="item.code"
                :value="item.code"
              >
              </el-option>
            </el-select>

            <el-select
              v-if="formData.launchType == 2"
              multiple
              filterable
              v-model="formData.launchEquipmentList"
              :placeholder="$t('lcd.Devices.Please Select Device Group')"
            >
              <el-option
                v-for="item in lcdTagOptions"
                :key="item.codeId"
                :label="item.codeName"
                :value="item.codeId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('lcd.Devices.AD Info')" prop="launchAdList">
            <el-descriptions
              v-if="formData.launchAdList.length > 0"
              :title="$t('lcd.Devices.AD List')"
              :column="1"
              direction="vertical"
            >
              <el-descriptions-item
                v-for="(item, index) in formData.launchAdList"
                :key="item.id"
                :label="$t('lcd.Devices.AD') + (index + 1)"
              >
                <div class="launchAdList" v-if="materialFlag == 'Img'">
                  <el-image
                    :src="item.url"
                    style="width: 100px; height: auto"
                  ></el-image>
                  <div class="time">
                    <span style="min-width: 60px">{{ $t('lcd.Devices.Duration')}}：</span>
                    <el-input
                      @change="handleTimeChange(item, index)"
                      size="mini"
                      :disabled="index > 0"
                      style="width: 60px"
                      v-model="item.delay"
                    ></el-input>
                    <span style="padding-left: 20px">S</span>
                  </div>
                </div>
                <div class="launchAdList" v-else>
                  <video style="width: 100px" :src="item.url"></video>
                  <div class="time">
                    <span style="min-width: 60px">{{ $t('lcd.Devices.Duration')}}：</span>
                    <el-input
                      size="mini"
                      style="width: 60px"
                      disabled
                      v-model="item.delay"
                    ></el-input>
                    <span style="padding-left: 20px">S</span>
                  </div>
                </div>
              </el-descriptions-item>
            </el-descriptions>
            <el-button icon="el-icon-plus" @click="handleOpen"
              >{{$t('lcd.Devices.Add AD Material')}}</el-button
            >
          </el-form-item>
          <el-form-item :label="$t('lcd.Devices.AD Time')" prop="timeRange">
            <el-date-picker
              v-model="formData.timeRange"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="-"
              :start-placeholder="$t('lcd.Devices.Start date')"
              :end-placeholder="$t('lcd.Devices.End date')"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>

          <!-- 保存按钮 -->
          <div class="form-btn-section">
            <el-button
              color="#28C76F"
              size="small"
              @click="handleClose('cancel')"
            >
              {{ $t("button.Cancel") }}</el-button
            >
            <el-button
              color="#28C76F"
              size="small"
              type="success"
              @click="handleConfirm('confirm')"
              >{{ $t("button.Confirm") }}</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>

    <MaterialSelect
      :materialFlag="materialFlag"
      ref="materialSelectRef"
      @doSelect="doSelect"
    ></MaterialSelect>
  </div>
</template>
<script>
import { getCodeList } from "@/libs/api/aps"; // 获取下拉列表list接口
import { getDeviceList, adLaunch } from "@/libs/api/lcd";
import MaterialSelect from "./MaterialSelect";
export default {
  name: "add-launch",
  components: {
    MaterialSelect,
  },
  props: {},
  data() {
    return {
      materialFlag: "All",
      userData: JSON.parse(localStorage.getItem("userData")),
      dialogVisible: false,
      formData: {
        storeId: localStorage.getItem("storeId"),
        launchType: "0", // 投放类型（0:全部 1:指定设备 2：标签类型 3：所有无分组标签设备）
        launchEquipmentList: [], // 投放设备	投放类型位1和2时选择
        launchAdList: [], // 投放广告信息
        timeRange: "",
        startTime: "", // 任务开始时间
        endTime: "", // 任务结束时间
        taskTerminal: "0",
      },
      rules: {
        launchEquipmentList: [
          {
            required: true,
            message: this.$t("formValidate.required fields"),
            trigger: "change",
          },
        ],
      },
      loading: false,
      lcdListOptions: [],
      launchTypeOptions: [
        {
          value: "0", // 所有设备
          label: this.$t('lcd.Devices.All Device'),
        },
        {
          value: "3", // 所有无分组标签设备
          label: this.$t('lcd.Devices.All No Tag Device'),
        },
        {
          value: "2", // 设备标签分组类型
          label: this.$t('lcd.Devices.Tag Devices'),
        },
        {
          value: "1", // 指定设备
          label: this.$t('lcd.Devices.Define Device'),
        },
      ],
      lcdPageParams: {
        screenCode: "", // 编号
        current: 1,
        size: 999,
        storeType: 2,
      },
      lcdTagOptions: [], // 设备分组列表
    };
  },
  watch: {
    dialogVisible: function (val) {
      if (val) {
        this.formData.storeId = localStorage.getItem("storeId")

      }
    },
  },
  created() {},
  mounted() {
    this.getCodeList('35')
  },
  methods: {
    async getCodeList(type) {
      try {
        const { data } = await getCodeList({ cateId: type });
        if (data.state === true) {
          let arr = data.data || [];
          if (type == '35') {
            this.lcdTagOptions = arr; // 设备组类型list
          }
        } else {
          this.$message.error(data.message);
        }
      } catch (err) {
        const { message } = err;
        this.$message.error(message);
      }
    },

    // 投放类型变化时，清空formData.launchEquipmentList
    launchTypeChange(){
      this.formData.launchEquipmentList = []
    },
    // 打开弹窗
    open() {
      this.dialogVisible = true;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
    },
    handleConfirm() {
      // :disabled="
      //           materialFlag == 'Img' && formData.launchAdList.length < 2
      //         "
      if (this.materialFlag == "Img" && this.formData.launchAdList.length < 2) {
        this.$message.error(this.$t('lcd.Devices.Error Info Number'));
        return;
      }
      if (this.formData.launchAdList.length < 1) {
        this.$message.error(this.$t('lcd.Devices.Error Info Null'));
        return;
      }
      const params = {
        ...this.formData,
        startTime: this.formData.timeRange[0], // 任务开始时间
        endTime: this.formData.timeRange[1], // 任务结束时间
      };
      console.log(params);
      // return;
      // if (!this.sleepStart || !this.sleepEnd) {
      //   this.$message.error("请设置定时息屏时间段");
      //   return;
      // }
      adLaunch(params).then((res) => {
        console.log(res);
        if (res.data.code == 1) {
          this.$message.success(this.$t('lcd.Devices.AD Success'));
          this.$emit("reGetList");
          this.dialogVisible = false;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    handleTimeChange(row, index) {
      if (index < 1) {
        this.formData.launchAdList.forEach((item) => {
          item.delay = row.delay;
        });
      }
    },

    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        const params = {
          ...this.lcdPageParams,
          code: query,
          storeId: localStorage.getItem("storeId"),
        };
        getDeviceList(params).then((res) => {
          console.log(res);
          this.loading = false;
          this.lcdListOptions = res.data.data.records;
        });
      } else {
        this.lcdListOptions = [];
      }
    },

    handleOpen() {
      this.$refs.materialSelectRef.open();
    },

    doSelect(val) {
      console.log("doSelect", val);
      const materialType = val.materialType;
      console.log("materialType", materialType);
      if (materialType == 0) {
        // 图片
        console.log("是图片呀");
        this.materialFlag = "Img";
      } else {
        // 视频
        console.log("是视频呀");
        this.materialFlag = "Video";
      }
      this.formData.launchAdList.push({
        id: val.materialId,
        name: val.materialName,
        url: val.originalUrl,
        delay: val.duration ? val.duration : 10,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.systemManage-create.create-image {
  ::v-deep .el-form--label-top .el-form-item__label {
    padding: 0 !important;
  }
  ::v-deep
    .el-descriptions__body
    .el-descriptions__table
    .el-descriptions-item__cell {
    line-height: 28px;
  }
  // .el-button {
  //   width: 110px;
  // }
  .dialog-footer {
    padding: 20px 0;
  }
  .form-box {
    width: 500px;
  }
  .file-list {
    display: flex;
  }
  .form-btn-section {
    margin-top: 0px;
  }
}
.launchAdList {
  display: flex;
  align-items: center;
  .time {
    margin-left: 40px;
    display: flex;
    align-items: center;
  }
}
</style>